"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingletonInitialization = void 0;
const shared_values_model_1 = require("./shared-values.model");
const use_shared_value_1 = require("./use-shared-value");
const use_once_1 = require("../use-once");
var SharedValueInitStatus;
(function (SharedValueInitStatus) {
    SharedValueInitStatus[SharedValueInitStatus["NotStarted"] = 0] = "NotStarted";
    SharedValueInitStatus[SharedValueInitStatus["Loading"] = 1] = "Loading";
    SharedValueInitStatus[SharedValueInitStatus["Error"] = 2] = "Error";
    SharedValueInitStatus[SharedValueInitStatus["Complete"] = 3] = "Complete";
})(SharedValueInitStatus || (SharedValueInitStatus = {}));
function useSingletonInitialization(key, fetch, apply) {
    const statusKey = getStateKey(key);
    const [state] = use_shared_value_1.useSharedValue(statusKey);
    use_once_1.useOnce(initialize);
    function initialize() {
        if (state.status !== SharedValueInitStatus.NotStarted)
            return;
        try {
            state.status = SharedValueInitStatus.Loading; // Mindful mutation to gate concurrent inits.
            const response = fetch();
            if (isAsyncResponse(response)) {
                handleAsyncValue(response);
            }
            else {
                handleValue(response);
            }
        }
        catch (error) {
            handleError(error);
        }
    }
    function handleAsyncValue(response) {
        response.then(value => handleValue(value)).catch(error => handleError(error));
    }
    function handleValue(value) {
        state.status = SharedValueInitStatus.Complete;
        apply(value);
    }
    function handleError(error) {
        state.status = SharedValueInitStatus.Error;
        state.error = error;
    }
    function isAsyncResponse(response) {
        return !!response['then'];
    }
    const loading = state.status === SharedValueInitStatus.Loading || state.status === SharedValueInitStatus.NotStarted;
    return [loading, state.error];
}
exports.useSingletonInitialization = useSingletonInitialization;
function defaultState() {
    return { status: SharedValueInitStatus.NotStarted, error: undefined };
}
function getStateKey(key) {
    return shared_values_model_1.createSharedValueKey(`${key.id}:status`, defaultState());
}
//# sourceMappingURL=use-singleton-initialization.js.map